import { render } from "./CollectionQualityChecks.vue?vue&type=template&id=29f42b8c&scoped=true"
import script from "./CollectionQualityChecks.vue?vue&type=script&lang=js"
export * from "./CollectionQualityChecks.vue?vue&type=script&lang=js"

import "./CollectionQualityChecks.vue?vue&type=style&index=0&id=29f42b8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f42b8c"]])

export default __exports__